"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => ({
  button: {
    alignItems: "center",
    color: theme.palette.primary.main,
    cursor: "pointer",
    display: "inline-flex",
    fontWeight: 700,
    gap: theme.spacing(1.5),
    justifyContent: "center",
    margin: "auto auto 0",
    minHeight: 40,
    padding: theme.spacing(1, 3),
    "& > span": {
      fontSize: 18,
      fontWeight: 700,
      textDecoration: "underline"
    }
  }
}));
var _default = exports.default = styles;